import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./step2Travel.css";
import "./step3Travel.css";

const Stepper = () => (
  <div className="s2-stepper">
    {["Traveler & Budget", "Schedule", "Cash Advance", "Documents", "Review & Submit"].map((label, index) => (
      <React.Fragment key={label}>
        <div className={`s2-step ${index < 2 ? "done" : index === 2 ? "active" : ""}`}>
          <span>{index < 2 ? <i className="ri-check-line" /> : index + 1}</span>
          <div><strong>{label}</strong><small>{index < 2 ? "Completed" : index === 2 ? "In progress" : "Pending"}</small></div>
        </div>
        {index < 4 && <i className={`s2-step-line ${index < 2 ? "done" : ""}`} />}
      </React.Fragment>
    ))}
  </div>
);

const Toggle = ({ value, onChange, options }) => (
  <div className="s3-toggle">
    {options.map((option) => <button type="button" key={option.value} className={value === option.value ? "active" : ""} onClick={() => onChange(option.value)}>{option.label}</button>)}
  </div>
);

const yesNo = [{ value: "yes", label: "Yes" }, { value: "no", label: "No" }];

const TravelRequestCreateStep3 = () => {
  const [travelType, setTravelType] = useState("international");
  const [previousClaim, setPreviousClaim] = useState("yes");
  const [unusual, setUnusual] = useState("yes");
  const [corporateCard, setCorporateCard] = useState("no");
  const [requestAdvance, setRequestAdvance] = useState("yes");
  const [amount, setAmount] = useState("");
  const amountExceeded = Number(amount) > 5000;
  const canRequest = previousClaim === "yes";

  return <div className="s2-page s3-page">
    <div className="s2-heading"><div><h1>Create Travel Request</h1><p>Step 3 of 5 · Cash Advance</p></div><Stepper /></div>
    <div className="s2-layout">
      <main className="s3-main">
        <section className="s2-card">
          <header className="s2-title"><span>1</span><div><h2>Cash Advance Checklist</h2></div></header>
          <div className="s3-body">
            <div className="s3-two-col compact">
              <label><span>Travel type</span><Toggle value={travelType} onChange={setTravelType} options={[{ value: "domestic", label: "Domestic" }, { value: "international", label: "International" }]} /></label>
              <label><span>Submitted previous cash advance claim?</span><Toggle value={previousClaim} onChange={setPreviousClaim} options={yesNo} /></label>
            </div>
            <div className="s3-info"><i className="ri-information-fill" /><div><strong>Lead time requirements:</strong><ul><li>Domestic travel — submit at least 7 working days before departure</li><li>International travel — submit at least 10 working days before departure</li></ul></div></div>
            <label><span>Are there unusual circumstances that reduce the lead time?</span><Toggle value={unusual} onChange={setUnusual} options={yesNo} /></label>
            {unusual === "yes" && <textarea rows="3" defaultValue="Annual leave from 28–29 April 2026 reduces the available travel lead time." />}
            <div className="s3-warning"><i className="ri-error-warning-fill" /><p>Finance has the right to reject payment before the travel date if submission is less than the required time frame — unless unusual circumstances are declared and accepted.</p></div>
          </div>
        </section>

        {!canRequest && <div className="s3-warning danger"><i className="ri-error-warning-fill" /><p>Please submit previous cash advance claim before requesting new cash advance.</p></div>}

        {canRequest && <section className="s2-card">
          <header className="s2-title"><span>2</span><div><h2>Cash Advance Request</h2></div></header>
          <div className="s3-body">
            <div className="s3-three-col">
              <label><span>Corporate credit card provided to you?</span><Toggle value={corporateCard} onChange={setCorporateCard} options={yesNo} /></label>
              <label><span>Are you requesting a cash advance?</span><Toggle value={requestAdvance} onChange={setRequestAdvance} options={[{ value: "yes", label: "Yes" }, { value: "no", label: "No, I will fund myself" }]} /></label>
              {requestAdvance === "yes" && <label><span>Requested Amount <b>*</b></span><div className={`s3-money ${amountExceeded ? "invalid" : ""}`}><span>RM</span><input type="number" min="0" max="5000" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="0.00" /></div>{amountExceeded && <small className="s3-error"><i className="ri-error-warning-line" /> Amount exceeds available quota. Please seek CEO approval for higher limits.</small>}</label>}
            </div>
            <label><span>Reason for Cash Advance</span><textarea rows="3" defaultValue="Transportation and meals during the Simpleview Summit 2026 in Houston, Texas." /></label>
          </div>
        </section>}
      </main>
      <aside className="s2-aside">
        <section><h3><i className="ri-refresh-line" /> What Happens Next</h3><p>After you submit:</p><ol><li>Your manager receives an approval request.</li><li>Once approved, Admin arranges flights, hotel and insurance.</li><li>Admin uploads booking confirmations.</li><li>Finance processes the cash advance payment.</li></ol></section>
      </aside>
    </div>
    <footer className="s2-actions"><Link to="/travel/create/step-2">Back</Link><span>Step 3 of 5 · Cash Advance</span><div><button type="button">Save as Draft</button><Link className={`primary ${!canRequest || amountExceeded ? "disabled" : ""}`} onClick={(event) => (!canRequest || amountExceeded) && event.preventDefault()} to="/travel/create/step-4">Continue</Link></div></footer>
  </div>;
};

export default TravelRequestCreateStep3;
